import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { formatDateWords } from '../../../shared/tenantClock';

function formatDateRange(start, end) {
  if (!start) return null;
  const fmt = (d) => formatDateWords(d);
  return end && end !== start ? `${fmt(start)} – ${fmt(end)}` : fmt(start);
}

// Shared "what's coming up" widget for the Home and Market Intel
// dashboards — same data (GET /api/trade-shows?upcoming=true), each
// dashboard supplies its own header/container chrome around this list.
function UpcomingTradeShowsList({ limit = 5 }) {
  const navigate = useNavigate();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/trade-shows', { params: { upcoming: 'true', limit } })
      .then((res) => setShows(res.data.data || []))
      .catch(() => setShows([]))
      .finally(() => setLoading(false));
  }, [limit]);

  if (loading) return <div style={{ fontSize: 13, color: '#888' }}>Loading...</div>;

  return (
    <div>
      {shows.length === 0 ? (
        <div style={{ fontSize: 13, color: '#888' }}>No upcoming Trade Shows scheduled.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {shows.map((s) => (
            <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderBottom: '1px solid #f0f2f5', paddingBottom: 8 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>
                  {s.website ? (
                    <a href={s.website} target="_blank" rel="noreferrer" style={{ color: '#1976d2' }}>{s.series?.name} {s.year}</a>
                  ) : (
                    <>{s.series?.name} {s.year}</>
                  )}
                </div>
                {s.location && <div style={{ fontSize: 12, color: '#888' }}>{s.location}</div>}
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>{formatDateRange(s.start_date, s.end_date)}</div>
            </div>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => navigate('/market-intel-trade-shows')}
        style={{ marginTop: 10, background: 'none', border: 'none', color: '#1976d2', cursor: 'pointer', fontSize: 12, padding: 0, textDecoration: 'underline' }}
      >
        View all Trade Shows
      </button>
    </div>
  );
}

export default UpcomingTradeShowsList;
